import React, { useMemo, useState } from 'react';
import { toaster, Notification } from 'rsuite';
import { isEqual } from 'lodash';
import { useCancellationsUIContext } from '../context/CancellationsUIContext';
import { dateFns, validator, FilterQueryParams } from '../../../../helpers';
import { FilterDate, FiltersSection } from '../../../../components';

// Helpers. (Any state afected on this functions)

export default function CancellationsFilters ({ dateFrom, setDateFrom, dateTo, setDateTo, searchText, setSearchText, disableButton, setDisableButton }) {
    // States

    // Cancellations UI Context
    const cancellationsUIContext = useCancellationsUIContext();
    const cancellationsUIProps = useMemo(() => {
        return {
            isLoading: cancellationsUIContext.isLoading,
            setIsLoading: cancellationsUIContext.setIsLoading,
            queryParams: cancellationsUIContext.queryParams,
            setQueryParams: cancellationsUIContext.setQueryParams,
        };
    }, [cancellationsUIContext]);

    const [showAlert, setShowAlert] = useState(true);
    // Modal state filter
    const [showFiltersDialog, setShowFiltersDialog] = useState(false);
    // Functions
    const prepareFilter = (queryParams, values) => {
        const { dateFrom, dateTo, searchText } = values;
        const newQueryParams = { ...queryParams };
        const filters = cancellationsUIProps.queryParams.filters || new FilterQueryParams();

        // Handle filter date range
        if (dateFrom && dateTo) {
            filters.between('created_at', dateFns.format(dateFrom, 'y-MM-dd 00:00:00'), dateFns.format(dateTo, 'y-MM-dd 23:59:59'));
        }
        else if (dateFrom) {
            filters.greaterThan('created_at', dateFns.format(dateFrom, 'y-MM-dd 00:00:00'));
        }
        else if (dateTo) {
            filters.lessThan('created_at', dateFns.format(dateTo, 'y-MM-dd 23:59:59'));
        }

        // Handle filter search
        if (searchText) {
            const term = `*${searchText}*`;

            if (validator.isInteger(searchText)) {
                filters.like('id', term);
            }
        }

        newQueryParams.filters = filters;
        return newQueryParams;
    };

    // queryParams, setQueryParams,
    const applyFilter = () => {
        const newQueryParams = prepareFilter(cancellationsUIProps.queryParams, { dateFrom, dateTo, searchText });

        if (!isEqual(newQueryParams, cancellationsUIProps.queryParams)) {
            newQueryParams.pageNumber = 1;
            // update list by queryParams
            cancellationsUIProps.setQueryParams(newQueryParams);
        }
        setShowFiltersDialog(false);
    };

    const handleChangeSearchText = (value) => {
        setSearchText(value);
        setDisableButton(!Number(value) && !!value.length);

        if (disableButton && showAlert) {
            toaster.push(<Notification type="info" header="Información">Debe ingresar un número de Id. Por favor, intentalo de nuevo.</Notification>);
            // Disable Alert
            setShowAlert(false);
            // Enable Alert
            setTimeout(() => {
                setShowAlert(true);
            }, 16000);
        }
    };

    const toggleFiltersDialog = () => setShowFiltersDialog(!showFiltersDialog);

    // Main Component

    return (
        <>
            {/* Modal */}
            <FilterDate
                open={showFiltersDialog}
                onClose={() => setShowFiltersDialog(false)}
                handleSearch={applyFilter}
                setDateFrom={setDateFrom}
                setDateTo={setDateTo}
            />
            <FiltersSection
                searchText={searchText}
                handleChangeSearchText={handleChangeSearchText}
                applyFilter={applyFilter}
                toggleFiltersDialog={toggleFiltersDialog}
                UIProps={cancellationsUIProps}
                disableButton={disableButton}
            />
        </>
    );
}
